import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
var CustomDataField = function CustomDataField(_ref) {
  var customData = _ref.customData,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(FormField, {
    label: t('form_custom_data')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: customData,
    onChange: onChange,
    disabled: isDisabled
  }));
};
export default CustomDataField;